import { WorkItemKind } from "./types";

const ALL_KINDS: readonly WorkItemKind[] = ["case", "task"] as const;

type DueWindow = "any" | "overdue" | "today" | "next7" | "next30" | "noDate";

const DUE_WINDOW_LABELS: Record<DueWindow, string> = {
  any: "Any due date",
  overdue: "Overdue",
  today: "Due today",
  next7: "Due in 7 days",
  next30: "Due in 30 days",
  noDate: "No due date",
};

type SortKey =
  | "dueDateAsc"
  | "dueDateDesc"
  | "createdDateDesc"
  | "createdDateAsc"
  | "householdAsc"
  | "titleAsc";

const SORT_LABELS: Record<SortKey, string> = {
  dueDateAsc: "Due date · Earliest → Latest",
  dueDateDesc: "Due date · Latest → Earliest",
  createdDateDesc: "Created · Newest → Oldest",
  createdDateAsc: "Created · Oldest → Newest",
  householdAsc: "Household · A → Z",
  titleAsc: "Name · A → Z",
};

const DEFAULT_SORT: SortKey = "dueDateAsc";

type FilterKey = "stage" | "assignee" | "household" | "dueWindow";

interface WorkItemFilters {
  stages: string[];
  assigneeNames: string[];
  // UNRESOLVED_HOUSEHOLD stands in for rows with no portal household id — they still
  // have a name and still need to be filterable.
  householdIds: string[];
  dueWindow: DueWindow;
}

const UNRESOLVED_HOUSEHOLD = "__unresolved__";

const DEFAULT_FILTERS: WorkItemFilters = {
  stages: [],
  assigneeNames: [],
  householdIds: [],
  dueWindow: "any",
};

// Render cost only — filtering is client-side, so no request per keystroke.
const SEARCH_DEBOUNCE_MS = 300;

// Salesforce field limits, enforced in the form so a write can't 422 on length.
const MAX_SUBJECT_LENGTH = 255;
const MAX_DESCRIPTION_LENGTH = 32000;

export {
  ALL_KINDS,
  DUE_WINDOW_LABELS,
  SORT_LABELS,
  DEFAULT_SORT,
  DEFAULT_FILTERS,
  UNRESOLVED_HOUSEHOLD,
  SEARCH_DEBOUNCE_MS,
  MAX_SUBJECT_LENGTH,
  MAX_DESCRIPTION_LENGTH,
};
export type { DueWindow, SortKey, FilterKey, WorkItemFilters };
